type ConfigCatFlag = {
  rawFlagName: string;
  savedFlagName: string;
  defaultValue: boolean;
};

export const CONFIG_CAT_FLAGS: Record<string, ConfigCatFlag> = {
  activityMonitoring: {
    rawFlagName: "develop_analyticsdashboard",
    savedFlagName: "activityMonitoring",
    defaultValue: false,
  },
  weeklyCheckIn: {
    rawFlagName: "develop_weeklycheckin",
    savedFlagName: "weeklyCheckIn",
    defaultValue: false,
  },
  advancedCsvUpload: {
    rawFlagName: "develop_advancedcsvupload",
    savedFlagName: "advancedCsvUpload",
    defaultValue: false,
  },
  teamsIntegration: {
    rawFlagName: "develop_teamsintegration",
    savedFlagName: "teamsIntegration",
    defaultValue: false,
  },
  multiLanguageCoachBo: {
    rawFlagName: "develop_multilanguagecoachbo",
    savedFlagName: "multiLanguageCoachBo",
    defaultValue: false,
  },
  aiServiceChatEnabled: {
    rawFlagName: "aiservice_chat_enabled",
    savedFlagName: "aiServiceChatEnabled",
    defaultValue: false,
  },
  s3Integration: {
    rawFlagName: "develop_s3integration",
    savedFlagName: "s3Integration",
    defaultValue: false,
  },
  goals: {
    rawFlagName: "develop_goals",
    savedFlagName: "goals",
    defaultValue: false,
  },
  checkInHarmDetection: {
    rawFlagName: "develop_checkinharmdetection",
    savedFlagName: "checkInHarmDetection",
    defaultValue: false,
  },
  variableCheckInFrequency: {
    rawFlagName: "develop_variablecheckinfrequency",
    savedFlagName: "variableCheckInFrequency",
    defaultValue: false,
  },
};

export const ADMIN_ROLE_ID = 1;
